import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Badge,
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import { imageBaseApi } from "../../../utilis/imageHelper";

const ChannelPartnerDetail = () => {
  const { id } = useParams();
  const [instituteData, setInstituteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchInstitute = async (id) => {
    if (!id) return;
    try {
      const response = await ChannelService.getdetails(id);
      setInstituteData(response);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstitute(id);
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!instituteData) return <p>No institute found</p>;
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Channel partners detail"
          pageTitle="Channel partners"
          breadcrumbItems={[
            { title: "Back to List", link: "/channel-partners" },
          ]}
        />
      </Container>

      <Card className="shadow-sm">
        <CardBody>
          {/* Header Section */}
          <div className="d-flex align-items-center gap-3 mb-4">
            <img
              src={imageBaseApi + instituteData?.logo?.url}
              alt={instituteData?.name}
              style={{
                width: 80,
                height: 80,
                objectFit: "contain",
                borderRadius: 8,
                background: "#f8f9fa",
                padding: 8,
              }}
            />

            <div>
              <h3 className="fw-bold mb-1">{instituteData?.name}</h3>
              <Badge color="primary" pill>
                Order Index: {instituteData?.orderIndex}
              </Badge>
            </div>
          </div>

          <hr />

          {/* Universities Section */}
          <h5 className="fw-semibold mb-3">Associated Universities</h5>

          {instituteData?.universities?.length > 0 ? (
            <Row className="">
              {instituteData.universities.map((uni) => (
                <Col md={6} lg={2} key={uni.id}>
                  <Card className="h-100 border">
                    <CardBody className="">
                      <CardImg
                        src={imageBaseApi + uni?.logo?.url}
                        alt={uni?.name}
                        className="avatar-xl object-fit-contain mb-3"
                        style={{
                          objectFit: "contain",
                          
                          background: "#f1f3f5",
                        }}
                      />

                      <div>
                        <h6 className="mb-0 fw-semibold">{uni.name}</h6>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <p className="text-muted fst-italic mb-0">
              No universities available.
            </p>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ChannelPartnerDetail;
